import {
  ActivityPointRankExcludedDto,
  ActivityPointRankMyDto,
  ActivityPointSeasonDto,
} from '@diritto/common/activityPoint/dtos/activity-point.dtos';
import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import styled from '@emotion/styled';
import { useActivityPointReward } from 'state-hooks/activityPoint/useActivityPointReward';
import { ContentBodyContainer } from 'ui-components/layout/containers/ContentBodyCenterContainer';

interface MyRankInfoProps {
  season: ActivityPointSeasonDto;
  myRank: ActivityPointRankMyDto;
  activityPointRankExcluded?: ActivityPointRankExcludedDto;
}

export const MyRankInfo = ({ season, myRank, activityPointRankExcluded }: MyRankInfoProps) => {
  const { reward, tierImage } = useActivityPointReward(season, myRank.rank, activityPointRankExcluded);

  return (
    <ContentBodyContainer>
      <StyledMyRankInfoWrapper>
        <StyledRankTitle>현재 순위</StyledRankTitle>
        <StyledMyRankInfo>
          {tierImage !== undefined ? (
            <StyledTierImage>
              <img src={tierImage} width={21} height={32} alt={tierImage} />
            </StyledTierImage>
          ) : null}
          <StyledLeft>
            <StyledRank>{myRank.rank ? `${myRank.rank}위` : '-'}</StyledRank>
            <StyledReward>{reward}</StyledReward>
          </StyledLeft>
          <StyledRight>
            <StyledRankPoint>{myRank.point}점</StyledRankPoint>
          </StyledRight>
        </StyledMyRankInfo>
      </StyledMyRankInfoWrapper>
    </ContentBodyContainer>
  );
};

const StyledRankTitle = styled.div`
  font-weight: ${FontWeight.Bold};
  ${Typography.Small};
`;

const StyledMyRankInfoWrapper = styled.div`
  padding-top: 16px;
  padding-bottom: 16px;
`;

const StyledMyRankInfo = styled.div`
  padding: 24px 0;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${Color.Gray200};
`;

const StyledLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const StyledRight = styled.div`
  margin-left: auto;
`;

const StyledTierImage = styled.div`
  margin-right: 16px;
  display: flex;
  align-items: center;
`;

const StyledRank = styled.div`
  font-weight: ${FontWeight.Medium};
  ${Typography.XXSmall};
`;

const StyledReward = styled.div`
  font-weight: ${FontWeight.Medium};
  ${Typography.XXXSmall};
  color: ${Color.Gray600};
`;

const StyledRankPoint = styled.div`
  font-weight: ${FontWeight.Medium};
  ${Typography.XXSmall};
  color: ${Color.Gray600};
`;
